import { Injectable } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { AnimationItem } from 'lottie-web';
@Injectable({
  providedIn: 'root',
})
export class LottieService {
  private coinSpinOptions: AnimationOptions = {
    path: '/assets/animations/coins-spin.json',
    loop: true,
    autoplay: true,
  };
  private coinJumpOptions: AnimationOptions = {
    path: '/assets/animations/coins-jump.json',
    loop: true,
    autoplay: true,
  };
  private medalOptions: AnimationOptions = {
    path: '/assets/animations/medal-first-place.json',
    loop: true,
    autoplay: true,
  };
  private bookOptions: AnimationOptions = {
    path: '/assets/animations/wired-flat-book.json',
    loop: true,
    autoplay: true,
  };

  private coinOptions: AnimationOptions = {
    path: '/assets/animations/coin.json',
    loop: true,
    autoplay: true
  };
  private newspaperAnimationOptions: AnimationOptions = {
    path: '/assets/animations/newspaper.json',
    loop: true,
    autoplay: true
  };

  private animationItem: AnimationItem;

  constructor() {}

  public get _coinSpinOptions() {
    return this.coinSpinOptions;
  }
  public get _coinJumpOptions() {
    return this.coinJumpOptions;
  }
  public get _medalOptions() {
    return this.medalOptions;
  }
  public get _coinOptions() {
    return this.coinOptions;
  }
  public get _bookOptions() {
    return this.bookOptions;
  }
  public get _newspaperAnimationOptions() {
    return this.newspaperAnimationOptions;
  }

  setLowAnimationSpeed(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
    this.animationItem.setSpeed(0.3);
  }
}
